<dw-container [options]="finalContainerOptions" *ngIf="chartPreferences">
    <div header class="dw-chart-tile-header">
        <div class="dw-chart-tile-heading">
            <div class="dw-chart-tile-title">{{chartPreferences?.containerTitle}}</div>
            <div class="dw-chart-tile-description" *ngIf="chartPreferences?.containerDescription">
                {{chartPreferences.containerDescription}}
            </div>
        </div>

        <button type="button" class="btn btn-link btn-sm dw-chart-header-toggle"
            *ngIf="data?.length > 0 && chartPreferences.gridPreferences?.showGrid && !hideToggle"
            [attr.aria-label]="showChart ? 'Show table' : 'Show chart'"
            [title]="showChart ? 'See table' : 'See chart'"
            (click)="toggleShowChart()">
            <i [class]="showChart ? 'fa fa-table' : 'fa fa-chart-bar'"></i>
        </button>
    </div>
    <div body class="inner-container">
        <div class="dw-chart-body-toggle"
            *ngIf="data?.length > 0 && !chartPreferences.showContainerTitle && chartPreferences.gridPreferences?.showGrid && !hideToggle">
            <button type="button" class="btn btn-link btn-sm"
                [attr.aria-label]="showChart ? 'Show table' : 'Show chart'"
                [title]="showChart ? 'See table' : 'See chart'"
                (click)="toggleShowChart()">
                <i [class]="showChart ? 'fa fa-table' : 'fa fa-chart-bar'"></i>
            </button>
        </div>
        <div *ngIf="data?.length==0" class="tile-no-data-container">
            <div class="no-data-label">No Data</div>
        </div>
        <ng-container *ngIf="data?.length>0">

            <div class="chart-container" *ngIf="chartConfig && showChart">
                <p-chart [type]="chartConfig?.chartType" [data]="chartConfig?.chartData" [query]="query"
                    [options]="chartConfig?.chartOptions" (onDataSelect)="onDataSelect($event)"></p-chart>
            </div>
            <div
                *ngIf="!showChart && !chartPreferences.gridPreferences?.useChartDataForGrid"
                [ngClass]="{'dw-total-row-grid': chartPreferences.gridPreferences?.showTotalsRow}">
                <dw-quick-grid [item]="query.RootTable" [query]="query" [data]="gridData" [columnPreferences]="columnPreferences" [useFlexColumns]="true" ConfigKeyPart="chart-data"
                    [loadCount]="loadCount" [customizeActions]="true" (gridEvent)="onGridEvent($event)" [allowConfiguration]="true"></dw-quick-grid>
            </div>
            <div *ngIf="!showChart && chartPreferences.gridPreferences?.useChartDataForGrid" class="chart-data-grid-container">
                <div class="chart-data-grid-scroll">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th *ngFor="let column of columnPreferences">{{column.label || column.field}}</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of gridData"
                              [ngClass]="{'dw-total-row': row[totalRowFlagField], 'dw-selectable-row': !row[totalRowFlagField]}"
                              [attr.tabindex]="row[totalRowFlagField] ? null : 0"
                              [attr.title]="row[totalRowFlagField] ? null : 'Select for drill down'"
                              (keydown.enter)="onSnapshotGridCellSelected(row, chartPreferences.categoryField, $event)">
                              <td *ngFor="let column of columnPreferences"
                                  (click)="onSnapshotGridCellSelected(row, column.field, $event)">{{formatGridValue(row[column.field], column.field)}}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="additional-text">{{additionalText}}</div>

            <ng-content>

            </ng-content>
        </ng-container>
    </div>
</dw-container>
